import * as React from "react";
import "./FileBrowser.scss";
import FileBrowser from "./FileBrowser";
export default class NapeosFileBrowser extends React.Component {
    render() {
        return (React.createElement(FileBrowser, { isDialogOpen: this.props.isDialogOpen, currentPath: this.props.currentPath, hasLocations: false, extensions: this.props.extensions, elements: this.props.elements, elementsStatus: this.props.elementsStatus, elementsError: this.props.elementsError, onAccept: this.props.onAccept, onCancel: this.props.onCancel, navigateDirectory: this.props.navigateDirectory }));
    }
}
//# sourceMappingURL=NapeosFileBrowser.js.map